module.exports = __webpack_public_path__ + "img/54.67ea307e.svg";